import {ConversationTypeContainer} from "./ConversationType.styled";

export const ConversationType = ({ type }) => {
  return (<ConversationTypeContainer>{type}</ConversationTypeContainer>);
};
